<template>
    <i :class="[icon, 'fa-2x p-3 block-icon']" />
</template>

<script>
export default {
    name: 'BlockIcon',
    props: {
        icon: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.block-icon {
    color: $bluezinho-500;
    border: 1px solid $bluezinho-500;
    border-radius: 100%;
    display: inline-block;
}
</style>
